import { createSelector } from 'reselect';
import getBookingTickets from '../getBookingTickets';
import isBookingLoaded from '../isBookingLoaded';

const getResaleInformation = createSelector(
  isBookingLoaded,
  getBookingTickets,
  (loaded, tickets) => (loaded ? tickets.map(({ resale }) => resale) : []),
);

export default getResaleInformation;
